// @flow
/**
 * Created by Mike Chung on 2/9/18.
 */

import type {BootstrapActionCollection} from "../actions/app/bootstrapAction";
import type {LoadFairConfigFailedAction} from "../actions/app/fairConfigAction";

export type BootstrapState = {

    completedCount: number,
    count: number,
    complete: number,
    error: boolean
};

const INITIAL_STATE: BootstrapState = {
    completedCount: 0,
    count: 0,
    complete: 0,
    error: false
};

export default function reducer(state: BootstrapState = INITIAL_STATE, action: BootstrapActionCollection | LoadFairConfigFailedAction): BootstrapState {

    switch (action.type) {
        case "app/BOOTSTRAP":
            return {
                ...state,
                count: action.counter
            };
        case "app/BOOSTRAP_PART_DONE":
            if (state.count > 0) {

                let newState = {
                    ...state,
                    completedCount: state.completedCount + 1
                };
                newState.complete = newState.completedCount / newState.count;
                return newState;
            } else {
                return state
            }
        case "app/LOAD_FAIR_CONFIG_FAILED_ACTION":
            return {
                ...state,
                error: true
            };
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/BootstrapReducer.js